import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../../../API/Api_Url";
import { FaEye, FaUsers } from "react-icons/fa";
import { DollarSign, MapPin, Calendar } from "lucide-react";

function AllAssignedJobRequirement() {
    const navigate = useNavigate();
    const [JobRequirements, setJobRequirements] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetAllAssignedJobRequirements = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(`api/labour/LabourGetSelectedJobs`);
            if (response?.data) {
                setJobRequirements(response.data);
            } else {
                setJobRequirements([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setJobRequirements([]);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetAllAssignedJobRequirements();
    }, []);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Pending":
                return "bg-yellow-100 text-yellow-800 border-yellow-200";
            case "Completed":
                return "bg-green-100 text-green-800 border-green-200";
            case "InProgress":
                return "bg-gray-100 text-gray-800 border-gray-200";
            case "Cancelled":
                return "bg-red-100 text-red-800 border-red-200";
            default:
                return "bg-gray-100 text-gray-800 border-gray-200";
        }
    };

    return (
        <div>
            {isUploading ? (
                <div className="flex items-center justify-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                    <p className="ml-4 text-gray-600">Loading assigned requirements...</p>
                </div>
            ) : JobRequirements?.length === 0 ? (
                <div className="text-center py-20">
                    <p className="text-xl text-gray-500">No assigned job requirements found.</p>
                </div>
            ) : (
                <div className="grid gap-6 grid-cols-1">
                    {JobRequirements?.map((req) => (
                        <div
                            key={req?._id}
                            className="bg-white rounded-2xl shadow-lg p-6 space-y-4"
                        >
                            <div className="flex justify-between items-center">
                                <h3 className="text-lg font-semibold text-gray-800">
                                    {req?.Skillsrequire?.join(", ")}
                                </h3>
                                <span
                                    className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                        req?.Status
                                    )}`}
                                >
                                    {req?.Status}
                                </span>
                            </div>
                            <p className="text-sm text-gray-500">
                                Posted by <span className="font-medium">{req?.User?.name}</span>
                            </p>
                            <div className="flex items-center text-sm text-gray-600">
                                <MapPin className="h-4 w-4 mr-1 text-gray-400" />
                                {req?.Location?.Address}, {req?.Location?.City}, {req?.Location?.State}
                            </div>

                            <div className="grid grid-cols-2 gap-4 text-sm">
                                <div className="flex items-center">
                                    <FaUsers className="h-4 w-4 mr-2 text-gray-400" />
                                    {req?.NumberOfLabours} Labour(s)
                                </div>
                                <div className="flex items-center">
                                    <Calendar className="h-4 w-4 mr-2 text-gray-400" />
                                    {req?.DurationInDays} Days
                                </div>
                                <div className="flex items-center">
                                    <DollarSign className="h-4 w-4 mr-2 text-gray-400" />
                                    ₹{req?.PerDayRate} / Day
                                </div>
                                <div className="flex items-center">
                                    <DollarSign className="h-4 w-4 mr-2 text-gray-400" />
                                    Total: ₹{req?.TotalBudget}
                                </div>
                            </div>

                            {req?.Notes && (
                                <p className="text-sm text-gray-500">
                                    <span className="font-medium">Notes:</span> {req?.Notes}
                                </p>
                            )}
                            <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                <span className="flex items-center">
                                    <Calendar className="h-4 w-4 mr-1" />
                                    Created: {formatDate(req?.createdAt)}
                                </span>
                                <div className="flex items-center gap-2">
                                    {/* <button
                    onClick={() => navigate(`/job/${req?._id}`)}
                    className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  >
                    <FaEye className="h-4 w-4" /> View Details
                  </button>
                  <button
                    onClick={() => alert("Apply functionality pending!")}
                    className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                  >
                    Apply Now
                  </button> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default AllAssignedJobRequirement;
